import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import Paginate from 'vuejs-paginate';
import download from 'downloadjs';
import Multiselect from 'vue-multiselect'
import {
    BasicSelect
} from 'vue-search-select'

export default {
    name: 'pallet-search-report',
    components: {
        VueElementLoading,
        BasicSelect,
        Paginate,
        download,
        Multiselect
    },
    props: [],
    data() {
        return {
            binpalletawbmps: '',
            palletReportDetails: [],
            hubdetails: '',
            isLoading: false,
            tableLoading: false,
            hublist: [],
            hubname: '',
            totalRows: 0,
            pageCount: 0,
            hubitem: {
                value: '',
                text: ''
            },
            limit: 10,
            selected: 'awb',
            options: [{
                    text: 'AWB Search',
                    value: 'awb'
                },
                {
                    text: 'MPS Search',
                    value: 'mps'
                },
                {
                    text: 'Paper Work',
                    value: 'paperno'
                },
                {
                    text: 'Pallet Search',
                    value: 'pallet'
                },
                {
                    text: 'Bin Number',
                    value: 'bin'
                },
                {
                    text: 'Destination Hub Name',
                    value: 'destinationhubid'
                },
                {
                    text: 'Client Name',
                    value: 'clientid'
                },
                {
                    text: 'Shipping Pin Code',
                    value: 'shippingpincode'
                },
                {
                    text: 'Sector',
                    value: 'sector'

                },
                {
                    text: 'Route',
                    value: 'route'

                },
                {
                text: 'Occupancy',
                value: 'occupancy'
                }
            ],
            formattedOccupancyOptions: [],
            currentHubId:'',
            clientid:'',
            clientname:'',
            clientlist:[],
            sectorlist: [],
            routelist: [], 
            occupancyOptions: ['Empty', 'Partial', 'Full'], // Occupancy options
            selectedSector: '',
            selectedRoute: '', 
            selectedOccupancy: '' ,
            showSectorDropdown: false,
            showRouteDropdown: false,
            awbNumbers: '',
            getAllBin:[],
            errorMessages: {
                required: '',
                limitExceeded: ''
              },
            hasAwbErrors: false
        }
    },
    computed: {

    },
    filters: {
    moment: function(date) {
      if (date == null || date == '')
      return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
      }
    },
    mounted() {
        var userTokenEncrypt = window.localStorage.getItem('userToken')
        var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
        var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
        this.token = JSON.parse(userToken)
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext)
        this.currentHubId = userdetail[0].HubId[0];
        this.getHubList();
        this.getClientList();
        this.getSectorList(this.currentHubId);
        this.getRouteList(this.currentHubId);
    },

    created(){
        this.formattedOccupancyOptions = this.formatOptions(this.occupancyOptions);
        
    },
   
    methods: {

        
        palletSearchReportDetails(hubid) {
            this.totalRows = 0
            this.palletReportDetails = []
            this.isLoading = true
            this.input = {}

            let selectednumber;
            if (this.selected === 'destinationhubid') {
                selectednumber = this.hubid;
            } else if (this.selected === 'clientid') {
                selectednumber = this.clientid;
            } else if (this.selected === 'awb') {
                selectednumber = this.awbNumbers.split(',').map(num => num.trim()).filter(num => num).join(',');
            } else if (this.selected === 'sector') {
                selectednumber = this.selectedSector.value;
            } else if (this.selected === 'route') {
                selectednumber = this.selectedRoute.value;
            } else if (this.selected === 'occupancy') {
                selectednumber = this.selectedOccupancy.value;
            } else {
                selectednumber = this.binpalletawbmps;
            }
            
            // query string
            let queryString = `number=${selectednumber}&type=${this.selected}&offset=${this.pageNo}&limit=${this.limit}&currentHubId=${this.currentHubId}`;

            axios({
                    method: 'GET',
                    'url': apiUrl.api_url_hubops + `getPalletSearchReport?${queryString}`,
                    'data': this.input,
                    headers: {
                        'Authorization': 'authkey xB84JJ89Hd25'
                    }
                })
                .then(result => {
                    if (result.data.ResultCode == 100) {
                        this.palletReportDetails = result.data.ResponseData;
                        this.$alertify.success(result.data.ReturnMessage)
                        this.totalRows = result.data.TotalCount
                        this.pageCount = this.totalRows < 10 ? 1 : Math.ceil(this.totalRows / 10);
                        this.pageCount = Math.ceil(this.totalRows / 10);
                        
                    } else {
                        this.$alertify.error(result.data.ReturnMessage)
                    }
                    this.isLoading = false
                }, error => {
                    this.isLoading = false
                    this.$alertify.error("Error Occured");
                    console.error(error)
                })
        },

        downloadSearchReportcsv() {
            this.tableLoading = true
            let selectednumber;
            if (this.selected === 'destinationhubid') {
                selectednumber = this.hubid;
            } else if (this.selected === 'clientid') {
                selectednumber = this.clientid;
            } else if (this.selected === 'awb') {
                selectednumber = this.awbNumbers.split(',').map(num => num.trim()).filter(num => num).join(',');
            } else if (this.selected === 'sector') {
                selectednumber = this.selectedSector.value;
            } else if (this.selected === 'route') {
                selectednumber = this.selectedRoute.value;
            } else if (this.selected === 'occupancy') {
                selectednumber = this.selectedOccupancy.value;
            } else {
                selectednumber = this.binpalletawbmps;
            }

            // query string
            let queryString = `number=${selectednumber}&type=${this.selected}&currentHubId=${this.currentHubId}`;

            axios({
                    method: 'GET',
                    'url': apiUrl.api_url_hubops + `getPalletSearchReport?${queryString}`,
                    headers: {
                        'Authorization': 'authkey xB84JJ89Hd25'
                    }
                })
                .then(result => {
                    this.tableLoading = false;
                    if (result.data.ResultCode == 100) {
                        let csvData = result.data.ResponseData.map((e) => {
                            return {
                                'Bin': e.binnumber,
                                'Bin Type': e.bintype == 0 ? "Rack": e.bintype == 1? "Floor" : e.bintype=="Pigeon Hole"? "Pigeon Hole" : "",
                                'Pallet': e.containernumber ,
                                'AWB No': e.parentawb,
                                'MPS/ PW ID / MPS Count': this.selected =='mps' || this.selected =='paperno' ? e.shipmentbagnumber:e.mpscount,
                                'Destination Hub': e.destinationhubname,
                                'Client ID': e.clientid,
                                'Shipping Pin Code': e.shippingpincode,
                                'Sector/Route':this.currentHubId == e.destinationhubid ?e.route:e.sector,
                                'Weight':e.weight,
                                'Occupancy':e.occupancy,
                                'Palletized By': e.lastmodifiedby,
                                'Date of Palletization': moment(e.lastmodifieddate).format('DD-MM-YYYY HH:mm:ss'),
                                'No of Palletized Days': e.noofpalledtdays,
                                
                            }
                        });
                        let csvFields = {
                            'Bin': 'Bin',
                            'Bin Type': 'Bin Type',
                            'Pallet': 'Pallet',
                            'AWB No': 'AWB No',
                            'MPS/ PW ID / MPS Count': 'MPS/ PW ID / MPS Count',
                            'Destination Hub': 'Destination Hub',
                            'Client ID': 'Client ID',
                            'Shipping Pin Code': 'Shipping Pin Code',
                            'Sector/Route':'Sector/Route',
                            'Weight':'Weight',
                            'Occupancy':'Occupancy',
                            'Palletized By': 'Palletized By',
                            'Date of Palletization': 'Date of Palletization',
                            'No of Palletized Days': 'No of Palletized Days'
                        }
                        this.jsonToCSV('BinReport_', csvData, csvFields);
                    } else {
                        this.$alertify.error(result.data.ReturnMessage)
                    }
                    
                }, error => {
                    this.tableLoading = false
                    this.$alertify.error("Error Occured");
                    console.error(error)
                })
        },

        jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
            var csvData = ''
            //Header
            if (this.title != null) {
                csvData += this.parseExtraData(this.title, '${data}\r\n')
            }
            //Fields
            for (let key in data[0]) {
                if (skipFilter.indexOf(key) == -1)
                    csvData += csvfield[key] + ','
            }
            csvData = csvData.slice(0, csvData.length - 1)
            csvData += '\r\n'
            //Data
            data.map(function(item) {
                for (let key in item) {
                    if (skipFilter.indexOf(key) == -1) {
                        var escapedCSV = item[key] + '' // cast Numbers to string
                        if (escapedCSV.match(/[,"\n]/)) {
                            escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
                        }
                        if (escapedCSV == 'null')
                            csvData += ',';
                        else {
                            if (dateFilder.indexOf(key) != -1)
                                csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
                            else
                                csvData += escapedCSV + ','
                        }
                    }
                }
                csvData = csvData.slice(0, csvData.length - 1)
                csvData += '\r\n'
            })
            //Footer
            if (this.footer != null) {
                csvData += this.parseExtraData(this.footer, '${data}\r\n')
            }
            filename += moment().format('DD-MM-YYYsetSelectedHubY') + '.csv';
            return this.export(csvData, filename, "application/csv");
            return csvData
        },
        export (data, filename, mime) {
            let blob = this.base64ToBlob(data, mime)
            download(blob, filename, mime)
            this.$alertify.success("Successful")
        },
        base64ToBlob(data, mime) {
            let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
            let bstr = atob(base64)
            let n = bstr.length
            let u8arr = new Uint8ClampedArray(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new Blob([u8arr], {
                type: mime
            })
        },

        getHubList() {
            this.input = ({})
            this.isLoading = true
            axios({
                    method: 'POST',
                    'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
                    'data': this.input,
                    headers: {
                        'authorization': 'authkey xB84JJ89Hd25',
                    }
                })
                .then(result => {
                    var HubDetails = result.data.ResponseData
                    for (var i = 0; i < HubDetails.length; i++) {
                        this.hublist.push({
                            "value": HubDetails[i].HubID,
                            "text": HubDetails[i].HubName + " (" + HubDetails[i].HubID + ")"

                        })
                    }
                    this.isLoading = false
                }, error => {
                    this.isLoading = false
                    console.error(error)
                })
        },

        setSelectedHub(hubitem) {
            this.hubid = hubitem.value;
            this.hubname = hubitem.text.split('(')[0].trim();
            this.hubitem = hubitem;

        },

        clearSelectedOption() {
            this.hubitem = {
                value: '',
                text: ''
            }
        },

        resetForm() {
            this.binpalletawbmps = ''
            this.tableLoading = false;
            this.palletReportDetails = []
            this.selected = 'awb'
            this.hubname = ''
            this.totalRows = 0
            this.pageCount = 0,
            this.hubitem = {
                value: '',
                text: ''
            },
            this.clientid = '',
            this.clientname = '',
            this.errorMessages.required = '';
            this.errorMessages.limitExceeded = '';
            this.hasAwbErrors = false;
            this.awbNumbers = '';
            this.$validator.reset()
        },

        selectRadio() {
            this.binpalletawbmps = ''
            this.palletReportDetails = []
            this.hubname = ''
            this.totalRows = 0
            this.pageCount = 0,
            this.hubitem = {
                value: '',
                text: ''
            },
            
            this.clientid = '',
            this.clientname = '',
            this.selectedSector = '';
            this.selectedRoute = '';
            this.selectedOccupancy = '';
            this.awbNumbers ='';
            this.$validator.reset()
        },

        getPaginationData(pageNum) {
            this.pageNo = 0
            this.pageNo = (pageNum - 1);
            this.palletSearchReportDetails()
        },

        async validateAwbNumbers() {
           
            this.errorMessages.required = '';
            this.errorMessages.limitExceeded = '';
            this.hasAwbErrors = false;
        
            const awbNumbers = this.awbNumbers.trim();
            if (awbNumbers === '') {
              this.errorMessages.required = 'AWB numbers are required.';
              this.hasAwbErrors = true;
              return false;
            }
        
            const awbList = awbNumbers.split(',').map(item => item.trim()).filter(item => item);
            if (awbList.length > 50) {
              this.errorMessages.limitExceeded = 'You have exceeded the maximum number of AWBs.';
              this.hasAwbErrors = true;
              return false;
            }
        
            return true;
          },

        onSubmit: function(event) {
            event.preventDefault(); 
            this.$validator.validateAll().then(async (result) => {
                // if (!result) {
                //   console.log('Form validation failed');
                //   return false;
                // }

            if(this.selected === 'awb'){
            
                const isAwbValid = await this.validateAwbNumbers();
                if (!isAwbValid) {
                  console.log('AWB validation failed');
                  return false;
                }
            }

                this.pageNo = 0
                this.$refs.paginate.selected = 0;
                this.palletSearchReportDetails()
            }).catch(() => {
                console.log('errors exist', this.errors)
            });
        },

        getClientList() {
    			this.input = ({
    				BusinessFlow: "Forward",
    				BusinessService: "Delivery"
    			})
    			this.isLoading = true;
    			axios({
    				method: "POST",
    				'url': apiUrl.api_url_hubops + 'clientbusiness/account/names/flowservice',
    				'data': this.input,
    				headers: {
    					'authorization': 'authkey xB84JJ89Hd25',
    				}
    			}).then(result => {
    				var response = result.data;
    				if (response.ResultCode == 100 && response.ResponseData.length > 0) {
    					for (var i = 0; i < response.ResponseData.length; i++) {
    						this.clientlist.push({
    							id: response.ResponseData[i].ClientBusinessAccountId,
    							text: response.ResponseData[i].ClientAccountNameAlise + ' (' + response.ResponseData[i].ClientBusinessAccountId + ')'
    						})
    					}
    				}
            this.isLoading = false;
    			}, error => {
            this.isLoading = false;
    				console.error(error);
    			});
    		},

        setSelectedClient(item) {
            this.clientid = item.id;
            this.clientname = item.text;
        },

        getSectorList(hubid){
            this.isLoading = true;
            axios({
                method: "GET",
                'url': apiUrl.api_url_hubops + `getdistinctSectorfromtable?hubId=${hubid}`,
                'data': this.input,
                headers: {
                    'authorization': 'authkey xB84JJ89Hd25',
                }
            }).then(result => {
                this.isLoading = false;
                if (result.data.ResultCode == 100 && result.data.ResponseData.length > 0) {
                    this.sectorlist = result.data.ResponseData.filter(sector => sector && sector !== 'null').map(sector => ({ text: sector, value: sector }));
                  }


            }, error => {
        this.isLoading = false;
                console.error(error);
            });

        },

        getRouteList(hubid){
            this.tableLoading = true;
            axios({
                method: "GET",
                'url': apiUrl.api_url_hubops + `getdistinctRoutefromtable?hubId=${hubid}`,
                'data': this.input,
                headers: {
                    'authorization': 'authkey xB84JJ89Hd25',
                }
            }).then(result => {
                this.tableLoading = false;
                if (result.data.ResultCode == 100 && result.data.ResponseData.length > 0) {
                    this.routelist = result.data.ResponseData.filter(route => route && route !== 'null').map(route => ({ text: route, value: route }));
                  }

            }, error => {
                this.tableLoading = false;
                console.error(error);
            });

        },

        exportAllBin() {
            this.tableLoading = true;

            let type = this.selected =='paperno' ? '&type=pigeonhole' : '';
            
            axios({
              method: 'GET',
              url: `${apiUrl.api_url_hubops}getAllbinforCurrentHubId?hubId=${this.currentHubId}${type}`,
              headers: {
                'authorization': 'authkey xB84JJ89Hd25',
              }
            })
            .then(result => {
              this.tableLoading = false;
          
              if (result.data.ResultCode === 100) {
                const getAllBin = result.data.ResponseData;
          
                // Map data to CSV format
                const csvDataBin = getAllBin.map(e => ({
                  'Bin': e.binnumber,
                  'Bin Type': e.bintype === 0 ? 'Rack' : e.bintype === 1 ? 'Floor' : e.bintype === 2? "Pigeon Hole" : '',
                  'Pallet': e.containernumber,
                  'AWB No': e.parentawb,
                  'MPS Count': e.mpscount,
                  'Destination Hub': e.destinationhubname,
                  'Client ID': e.clientid,
                  'Shipping Pin Code': e.shippingpincode,
                  'Sector/Route':this.currentHubId == e.destinationhubid ?e.route:e.sector,
                  'Weight': e.weight,
                  'Occupancy': e.occupancy,
                  'Palletized By': e.lastmodifiedby,
                  'Date of Palletization': moment(e.lastmodifieddate).format('DD-MM-YYYY HH:mm:ss'),
                  'No of Palletized Days': e.noofpalledtdays,
                }));
          
                // Define CSV fields
                const csvFields = {
                  'Bin': 'Bin',
                  'Bin Type': 'Bin Type',
                  'Pallet': 'Pallet',
                  'AWB No': 'AWB No',
                  'MPS Count': 'MPS Count',
                  'Destination Hub': 'Destination Hub',
                  'Client ID': 'Client ID',
                  'Shipping Pin Code': 'Shipping Pin Code',
                  'Sector/Route': 'Sector/Route',
                  'Weight': 'Weight',
                  'Occupancy': 'Occupancy',
                  'Palletized By': 'Palletized By',
                  'Date of Palletization': 'Date of Palletization',
                  'No of Palletized Days': 'No of Palletized Days'
                };
          
                // Convert JSON data to CSV and trigger download
                this.jsonToCSV('Report_', csvDataBin, csvFields);
              } else {
                this.$alertify.error(result.data.ReturnMessage);
              }
            })
            .catch(error => {
              this.tableLoading = false;
              this.$alertify.error('Error Occurred');
              console.error(error);
            });
          },


        getPalletizationDataPrint() {
          const printWindow = window.open('', '', 'height=600,width=800');
          printWindow.document.write('<html><head><title>Print Table</title>');
          printWindow.document.write('<style>table { border-collapse: collapse; width: 100%; } th, td { border: 1px solid black; padding: 8px; text-align: left; } th { background-color: #f2f2f2; }</style>');
          printWindow.document.write('</head><body >');
          printWindow.document.write(document.querySelector('.table-bordered').outerHTML);
          printWindow.document.write('</body></html>');
          printWindow.document.close();
          printWindow.focus();
          printWindow.print();
        },

        formatOptions(val) {
          return val.map(val => ({ text: val, value: val }));
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/Palletization/Reports/Reports.js